import {
  Capacitor,
  registerPlugin
} from '@capacitor/core';

import {
  BleClient
} from '@capacitor-community/bluetooth-le';

const VeritasBle =
  registerPlugin('VeritasBle');

const VERITAS_PREFIX =
  '7a710001-';

let iosBleInitialized = false;

export function isVeritasBleAvailable() {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  const platform =
    Capacitor.getPlatform();

  return (
    platform === 'android' ||
    platform === 'ios'
  );
}

async function scanForVeritasSignalIos(
  timeoutMs = 6000
) {
  const duration =
    Math.max(
      1000,
      Math.min(
        15000,
        Number(timeoutMs) || 6000
      )
    );

  if (!iosBleInitialized) {
    await BleClient.initialize();
    iosBleInitialized = true;
  }

  return new Promise(
    (resolve, reject) => {
      let finished = false;
      let timer = null;

      function finish(
        result,
        error = null
      ) {
        if (finished) {
          return;
        }

        finished = true;

        if (timer) {
          clearTimeout(timer);
        }

        Promise.resolve(
          BleClient.stopLEScan()
        )
          .catch(() => {
            // Scan may already have stopped.
          })
          .finally(() => {
            if (error) {
              reject(error);
            } else {
              resolve(result);
            }
          });
      }

      timer = setTimeout(
        () => {
          finish({
            found: false
          });
        },
        duration
      );

      BleClient.requestLEScan(
        {
          allowDuplicates: true
        },
        scanResult => {
          const advertisedUuids =
            Array.isArray(
              scanResult?.uuids
            )
              ? scanResult.uuids
              : [];

          const signalToken =
            advertisedUuids
              .map(uuid =>
                String(uuid)
                  .toLowerCase()
              )
              .find(uuid =>
                uuid.startsWith(
                  VERITAS_PREFIX
                )
              );

          if (!signalToken) {
            return;
          }

          finish({
            found: true,
            signalToken,
            rssi:
              Number.isFinite(
                scanResult?.rssi
              )
                ? scanResult.rssi
                : null
          });
        }
      ).catch(error => {
        finish(
          null,
          error
        );
      });
    }
  );
}

export async function scanForVeritasSignal(
  timeoutMs = 6000
) {
  if (!isVeritasBleAvailable()) {
    throw new Error(
      'Veritas Bluetooth scanning is available only in the mobile app.'
    );
  }

  const platform =
    Capacitor.getPlatform();

  if (platform === 'android') {
    // Keep the existing proven Android
    // implementation unchanged.
    return VeritasBle.scanForSignal({
      timeoutMs
    });
  }

  if (platform === 'ios') {
    return scanForVeritasSignalIos(
      timeoutMs
    );
  }

  throw new Error(
    'Bluetooth check-in is not available on this device.'
  );
}